
import GoodsZoom from '@/components/GoodsZoom'
import GoodsIntroduce from '@/components/GoodsDesc/GoodsIntroduce'
import TitleBox2 from '@/components/CSS/TitleBox2'
const GoodsTransaction = () => import('@/components/GoodsDesc/GoodsTransaction')
const GoodsQqGroup = () => import('@/components/GoodsDesc/GoodsQqGroup')
const TimeCountdown = () => import('@/components/TimeCountdown')
import { addBlankPath, deleteFixedEnName, mappingFieldToStr, toDom } from '@/utils/validate'
import { mapGetters } from 'vuex'
import { openBuyAuth, openHackBargain } from '@/settings'
// 回收
// import {
//   reGoodsDetails,
//   buyReGoods,
//   recycleConfigList,
//   addRecycleQuote,
// } from "@/api/recovery";
import getPageTitle from '@/utils/get-page-title'
export default {
	components: {
		TitleBox2,
		GoodsZoom,
		GoodsIntroduce,
		GoodsTransaction,
		TimeCountdown,
		GoodsQqGroup
	},
	metaInfo() {
		return {
			title: `${getPageTitle(this.detailsData.goodsNo + '-' + this.detailsData.gameName + '详情')}`,
			meta: [
				{
					vmid: 'description',
					name: 'description',
					content: this.detailsData.description
				},
				{
					vmid: 'keywords',
					name: 'keywords',
					content: `${this.detailsData.gameIdName}详情 - ${this.detailsData.description}`
				}
			]
		}
	},
	computed: {
		...mapGetters({ userinfo: 'user/userinfo', customerInfo: 'ry/customerInfo', token: 'user/token' })
	},
	data() {
		const validatePrice = (rule, value, callback) => {
			if (!value) {
				callback(new Error('请输入报价'))
			} else if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(value)) {
				callback(new Error('请输入有效价格'))
			} else if (value >= this.detailsData.price) {
				callback(new Error('砍价不能大于商品原价，请重新输入'))
			} else if (value < this.detailsData.price * 0.7) {
				callback(new Error('商品砍价不能低于商品价格的70%，请重新输入'))
			} else {
				callback()
			}
		}
		return {
			openHackBargain,
			show: true,
			unlockTime: null,
			timers: null,
			dialogKanVisible: null,
			goodsType: null,
			goodsNo: null,
			buyType: '',
			detailsData: {
				gameIdName: '游戏'
			},
			propertyConfig: [],
			propertyRecommendConfig: [],
			tabNavFixed: false,
			kanFrom: {
				price: null
			},
			kanRules: {
				price: [{ required: true, validator: validatePrice, trigger: 'blur' }]
			},
			kanLoading: false,
			tabTitle: [
				{
					title: '商品介绍',
					value: 'goodsDesc'
				}
			],
			tabTitleName: 'goodsDesc',
			backListPath: null,
			customerServiceObj: null,
			collectionStatus: false,
			collection: 'https://oss.pzds.com/imgv2/collection_1.png',
			unCollection: 'https://oss.pzds.com/imgv2/collection.png',
			tradingNoticeData: [], // 交易须知
			serviceData: [], // 客服交易群
			// 报价弹窗
			buyOnceDialog: false,
			diaPrice: '', //报价
			reConfig: {}, //回收配置
			buyQuickDialog: false //直接回收弹窗
		}
	},
	methods: {
		onSubmitKanForm(mode) {
			if (mode === 'close') {
				this.dialogKanVisible = false
				return
			}
			this.$refs['kanFrom'].validate(valid => {
				if (valid) {
					this.kanLoading = true
					let p = {
						action: {
							goodsNo: this.goodsNo,
							bargainPrice: parseFloat(this.kanFrom.price),
							imUserId: this.customerInfo.targetId
						}
					}
					this.$api.goodsKan(p).then(res => {
						this.kanLoading = false
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.$refs['kanFrom'].resetFields()
						this.dialogKanVisible = false
						// this.$message.success(res.info);
						const data = res.data
						data.goodsPrice = this.detailsData.price // 商品原价
						this.$store.commit('game/SET_PAY_INFO', data) // 支付信息
						this.$router.push(`/confirmOrder/payment?goodsNo=${this.$route.query.goodsNo}&goodsCatalogueId=${this.$route.query.goodsCatalogueId}&gameName=${this.detailsData.gameIdName}`)
					})
				}
			})
		},
		mappingFieldToStrHandle(detailsData, item) {
			return mappingFieldToStr(detailsData, item)
		},
		/**
		 * 切换商品描述的tab
		 */
		checkTabTitle(item) {
			this.tabTitleName = item.value
			if (item.value === 'tradingNotice' && !this.tradingNoticeData.length) {
				this.getListTradingNotice()
			}
			if (item.value === 'qqGroup' && !this.serviceData.length) {
				this.getListCustomerService()
			}

			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			if (scrollTop > 599) {
				toDom(document?.querySelector('#contentTop'), 0)
			}
		},
		handleGoodsScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
			this.tabNavFixed = scrollTop >= 599 ? true : null
		},
		/**
		 * 获取详情数据
		 */
		getGoodsDetails() {
			return new Promise(resolve => {
				let p = {
					action: {
						goodsNo: this.goodsNo
					}
				}
				this.goodsType = this.$route.query.goodsCatalogueId ? parseInt(this.$route.query.goodsCatalogueId) : null
				this.$api.reGoodsDetails(p).then(res => {
					this.show = false
					if (!res.success) {
						this.$message.error(res.info)
						return
					}
					this.goodsType = parseInt(res.data.goodsCatalogueId)
					this.backListPath = {
						goodsCatalogueId: res.data.goodsCatalogueId,
						gameId: res.data.gameId,
						gameName: res.data.gameIdName
					}
					this.detailsData = res.data
					this.detailsData.goodsImg = res.data.goodsImg && res.data.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
					// if (res.data.detailsImages.length) {
					//   this.detailsData.detailsImages = res.data.detailsImages.map(
					//     (item) =>
					//       item.replace(
					//         "?x-oss-process=style/jpg90",
					//         "?x-oss-process=style/titleImg"
					//       )
					//   );
					// }
					resolve()
				})
			})
		},
		/**
		 * 获取活的配置项
		 */
		getGoodsListPropertyConfig() {
			let p = {
				action: {
					gameId: this.detailsData.gameId,
					goodsCatalogueId: this.detailsData.goodsCatalogueId,
					inRecovery: true
				}
			}
			this.$api.goodsListPropertyConfig(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				// 商品介绍的基本属性
				let propertyConfig = data.filter(item => item.showDetails)
				this.propertyConfig = deleteFixedEnName(propertyConfig)
				// 封面图片位置的基本属性
				let baseConfig = data.filter(item => item.showDetails && item.recommend)
				this.propertyRecommendConfig = deleteFixedEnName(baseConfig)
			})
		},
		// 获取回收配置
		getRecycleConfigList() {
			this.$api.recycleConfigList().then(res => {
				this.reConfig = res.data
			})
		},
		// 商家直接回收
		showKan() {
			console.log(this.goodsNo)
			if (!this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}
			// if (this.userinfo && !this.userinfo.isRealName) {
			//   this.$confirm("需先完成实名才能购买", "提示", {
			//     confirmButtonText: "前去实名",
			//     cancelButtonText: "取消",
			//     type: "warning",
			//   })
			//     .then(() => {
			//       addBlankPath("/account/authHome");
			//     })
			//     .catch(() => {});
			//   return;
			// }
			this.buyQuickDialog = true
		},
		// 商家直接回收
		goQuickRecovery() {
			this.$api
				.buyReGoods(this.goodsNo)
				.then(res => {
					this.buyQuickDialog = false
					if (res.success) {
						this.$message.success('回收成功')
						this.getGoodsDetails()
					} else {
						this.$message.error(res.info)
					}
				})
				.catch(() => {
					this.buyQuickDialog = false
				})
		},
		/**
		 * 立即购买
		 * @constructor
		 */
		buyNow() {
			if (openBuyAuth && !this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}

			// if (this.userinfo && !this.userinfo.isRealName) {
			//   this.$confirm("需先完成实名才能购买", "提示", {
			//     confirmButtonText: "前去实名",
			//     cancelButtonText: "取消",
			//     type: "warning",
			//   })
			//     .then(() => {
			//       addBlankPath("/account/authHome");
			//     })
			//     .catch(() => {});
			//   return;
			// }
			this.buyOnceDialog = true
		},
		goRecovery() {
			const info = {
				action: {
					goodsNo: this.goodsNo,
					price: this.diaPrice
				}
			}
			if (info.action.price == this.detailsData.price) {
				this.buyReGoods(info)
				return
			}
			if (info.action.price > this.detailsData.price) {
				this.$message.error('价格不能大于意向价')
				return
			}
			if (!info.action.price || info.action.price <= 0) {
				this.$message.error('价格不能小于0')
				return
			}
			if (this.detailsData.maxBidPrice > 0 && info.action.price < (this.detailsData.maxBidPrice * 100 * this.reConfig.quote_rate) / 10000 + this.detailsData.maxBidPrice) {
				if ((this.detailsData.maxBidPrice * 100 * this.reConfig.quote_rate) / 10000 + this.detailsData.maxBidPrice < this.detailsData.price) {
					this.$message.error(
						`您的报价需高于当前最高价的${this.reConfig.quote_rate}% ${(this.detailsData.maxBidPrice * 100 * this.reConfig.quote_rate) / 10000 + this.detailsData.maxBidPrice}元`
					)
					return
				} else if (info.action.price != this.detailsData.price) {
					this.$message.error('您需要报价' + this.detailsData.price + '元')
					return
				}
			}
			if (!this.detailsData.maxBidPrice && info.action.price < (this.detailsData.price * 100 * this.reConfig.init_rate) / 10000) {
				this.$message.error(`您的报价需高于意向价的${this.reConfig.quote_rate}% ${(this.detailsData.price * 100 * this.reConfig.init_rate) / 10000}元`)
				return
			}
			this.buyReGoods(info)
		},
		buyReGoods(info) {
			this.$api
				.addRecycleQuote(info)
				.then(res => {
					this.buyOnceDialog = false
					if (res.success) {
						this.$message.success('报价成功')
						this.buyOnceDialog = false
						this.getGoodsDetails()
					} else {
						this.$message.error(res.info)
					}
				})
				.catch(err => {
					this.buyOnceDialog = false
					this.$message.error(err)
				})
		},
		/**
		 * 客服交易群
		 */
		getListCustomerService() {
			let p = {
				action: {
					gameId: this.detailsData.gameId,
					goodsCatalogueId: this.detailsData.goodsCatalogueId,
					linkType: 'OFFICIAL_GROUP_QQ'
				}
			}
			this.$api.listCustomerServicePublic(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.empty = false
				this.serviceData = res.data
			})
		},
		/**
		 * 交易须知
		 */
		getListTradingNotice() {
			let p = {
				action: {
					gameId: this.detailsData.gameId,
					goodsCatalogueId: this.detailsData.goodsCatalogueId
				}
			}
			this.$api.listTradingNotice(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.empty = false
				this.tradingNoticeData = res.data
			})
		},
		/**
		 * 点击收藏事件
		 */
		collectionHandler() {
			if (!this.token) {
				this.$message.warning('请先登录')
				this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
				return
			}
			this.collectionStatus = !this.collectionStatus
			if (this.collectionStatus) {
				this.collectionAddHandler()
			} else {
				this.collectionCancelHandler()
			}
		},
		/**
		 * 加入收藏
		 */
		collectionAddHandler() {
			let p = {
				action: {
					goodsNo: this.goodsNo
				}
			}
			this.$api.collectionAdd(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.$message.success(res.info)
			})
		},

		/**
		 * 取消收藏
		 */
		collectionCancelHandler() {
			this.$confirm('您确定要取消收藏吗？', '提示', {
				confirmButtonText: '确定',
				type: 'error'
			})
				.then(() => {
					let p = {
						action: {
							goodsNo: this.goodsNo
						}
					}
					this.$api.collectionCancel(p).then(res => {
						if (!res.success) {
							this.$message.error(res.info)
							return
						}
						this.$message.success(res.info)
					})
				})
				.catch(() => {
					this.collectionStatus = true
				})
		},
		/**
		 * 商品收藏状态
		 */
		getCollectionGoodsStatus() {
			let p = {
				action: {
					goodsNo: this.goodsNo
				}
			}
			this.$api.collectionGoodsStatus(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.collectionStatus = res.data
			})
		},
		back() {
			this.$router.go(-1)
		}
	},
	async created() {
		this.goodsNo = this.$route.query.goodsNo
		await this.getGoodsDetails()
		if (this.goodsType === this.$enum.GOODS_TYPE.ID) this.getListCustomerService()
		this.getGoodsListPropertyConfig()
		this.getCollectionGoodsStatus()
	},
	mounted() {
		setTimeout(() => {
			window.addEventListener('scroll', this.handleGoodsScroll, true)
		}, 300)
		if (this.$route.query.buyType) {
			this.buyType = this.$route.query.buyType
		} else {
			this.buyType = ''
		}
		this.getRecycleConfigList()
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleGoodsScroll, true)
	}
}
